// extracted by mini-css-extract-plugin
export default {"container":"components-parity-insight-breakdown-block-module__container","infinite-scroller":"components-parity-insight-breakdown-block-module__infinite-scroller"};